import * as React from 'react';
import dashboardWrapper from '../..//wrappers/dashboard';
import { t } from '~/i18n';
import AlertTableContainer from '~/containers/Alerts/AlertTable';

const AlertsPage = () => (
  <>
    <AlertTableContainer />
  </>
);

export default dashboardWrapper(AlertsPage, t('menu.dashboard.alerts'));
